/**
 * Componente de escolha de icones
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.IconPicker = (function () {

    function IconPicker () {

        Monet.UI.Fields.Base.apply (this, arguments);

        this.createBaseStructure();
        this.images = '';

        this.createElement = function () {

            var divParent = document.createElement('div');
            var divControls = document.createElement('div');
            var divImagePickerIconLibrary = document.createElement('div');
            var divImagePickerIconSelected = document.createElement('div');
            var divImagePickerIconChoose = document.createElement('div');
            var divImagePicker = document.createElement('div');
            var divIcons = document.createElement('div');

            divParent.setAttribute('class', 'controls');
            divParent.setAttribute('id', 'icons');

            divControls.setAttribute('class', 'controls');

            divIcons.setAttribute('class', 'iconsSelect');
            divIcons.setAttribute('id', 'divIcons');

            const alertTriangleRedImage = require("static/images/event/alert_triangle_red.png");
            divImagePickerIconSelected.setAttribute('class', 'imagePickerIconSelected');
            divImagePickerIconSelected.style.background = "url(" + alertTriangleRedImage + ")";
            divImagePickerIconSelected.style.backgroundRepeat = 'no-repeat';

            const downImage = require("static/images/event/down.png");
            divImagePickerIconChoose.setAttribute('class', 'imagePickerIconChoose');
            divImagePickerIconChoose.style.background = "url(" + downImage + ")";
            divImagePickerIconChoose.style.backgroundRepeat = 'no-repeat';

            divIcons.appendChild(divImagePickerIconSelected);
            divIcons.appendChild(divImagePickerIconChoose);

            divImagePicker.setAttribute('class', 'imagePicker');
            divImagePicker.setAttribute('id', 'imagePicker');

            divImagePickerIconLibrary.setAttribute('class', 'imagePickerIconLibrary');

            divImagePicker.appendChild(divImagePickerIconLibrary);

            divParent.appendChild(divIcons) ;
            divParent.appendChild(divImagePicker);

            this.rootEl.setAttribute("class", "MonetUIFieldIconPicker");

            this.rootEl.appendChild(divParent);
        };

        this.getValue = function () {
            var iconSelected = this.rootEl.querySelector('.imagePickerIconSelected');
            if( !iconSelected.style.background ) {
                iconSelected = '';
            } else {
                iconSelected = iconSelected.style.background.substring(iconSelected.style.background.indexOf('images'), (iconSelected.style.background.indexOf('png')+3));
            }
            return iconSelected;
        };

        this.setValue = function (value) {
            const image = require("./../../../static/" + value);
            var iconSelected = this.rootEl.querySelector('.imagePickerIconSelected');
            iconSelected.style.background = "url(" + image + ")";
            iconSelected.style.backgroundRepeat = 'no-repeat';
        };

        this.render = function () {

            this.createElement();
            this.addEventListener();
            return this.rootEl;

        };

        this.setPlaceHolder = function (text) {

            if (this.input) {
                this.input.placeholder = text;
            } else {
                var error = new Monet.Exception.ReturnError(
                    this, 'Monet.UI.Fields.TextField: setPlaceHolder: this.input is null'
                );

                error.console();
            }

        };

        this.addEventListener = function () {
            var divIcons = this.rootEl.querySelector('#divIcons');
            var root = this.rootEl;
            var that = this;

            var functionCloseDivIcons = function(e){
                if( e.target.className !== "imagePickerIcon") {
                    e.stopPropagation();
                }

                var imagePicker = root.querySelector('#imagePicker');
                if (imagePicker && imagePicker.style.display === 'block') {
                    imagePicker.style.display = 'none';
                    const downImage = require("static/images/monet/menu_down.svg");
                    var imageChoose = root.querySelector('.imagePickerIconChoose');
                    imageChoose.style.background = "url(" + downImage + ")";
                    imageChoose.style.backgroundRepeat = 'no-repeat';
                }
                var body = document.getElementsByTagName('body');
                body[0].removeEventListener('click', functionCloseDivIcons, true);
            };

            divIcons.addEventListener('click', function (e) {
                e.stopPropagation();
                e.cancelBubble = true;
                var divIconPicker = root.querySelector('#imagePicker');
                if (divIconPicker.style.display === 'block') {
                    divIconPicker.style.display = 'none';
                } else {
                    divIconPicker.style.display = 'block';
                    const upImage = require("static/images/monet/menu_down_active.svg");
                    var imageChoose = root.querySelector('.imagePickerIconChoose');
                    imageChoose.style.background = "url(" + upImage + ")";
                    imageChoose.style.backgroundRepeat = 'no-repeat';
                    that.setImages();
                }

                var body = document.getElementsByTagName('body');
                body[0].removeEventListener('click', functionCloseDivIcons, true);
                body[0].addEventListener('click', functionCloseDivIcons, true);
            }, true);
        };

        this.setImages = function () {

            var divIconPickerLibary = this.rootEl.querySelector('.imagePickerIconLibrary'),
                icon,
                root = this.rootEl,
                iconOnClick = function(e) {

                    if (e.stopPropagation) {
                        e.stopPropagation();
                    } else {
                        e.cancelBubble = true;
                    }
                    var iconSelected = e.target;

                    var urlImage = iconSelected.style.background.substring((iconSelected.style.background.indexOf('url(') + 5), (iconSelected.style.background.indexOf('png') + 3));
                    var imageSelected = root.querySelector('.imagePickerIconSelected');
                    imageSelected.style.background = "url(" + urlImage + ")";
                    imageSelected.style.backgroundRepeat = 'no-repeat';
                };

            if ( divIconPickerLibary.children.length === 0) {
                for (var i = 0, size = this.images.length; i < size; i++ ) {
                    const imagePath = require("./../../../static" + this.images[i]);
                    icon = document.createElement('div');
                    icon.setAttribute("class", "imagePickerIcon");
                    icon.style.background = "url(" + imagePath +")";
                    icon.style.backgroundRepeat = 'no-repeat';
                    divIconPickerLibary.appendChild(icon);

                    icon.addEventListener('click', iconOnClick);
                }
            }
        };

    }

    return IconPicker;

}());